export class SummaryForSupplierDTO {
    Pending: number;
    Submitted: number;
    Rejected: number;
    Approved: number;
    Incomplete: number;
    OpenAction: number;
}
